import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@asambleas-env/environment';

@Pipe({
  name: 'churchAvatar'
})
export class ChurchAvatarPipe implements PipeTransform {

  transform(value: string): any {

    if (!value || value == 'null') {
      return 'assets/images/generic-avatar.png';
    }

    else {
      return environment.apiEndPoint + '/church-images/' + value;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/church-avatar.pipe.ts